var exports = {
  "Jy": "ConversationLoader__kboigt",
  "Rd": "fade-in-skeleton__TDlNjh",
  "cx": "ConversationLoader__assistantGroup__uBxqRz",
  "D4": "ConversationLoader__userGroup__yepJJX",
  "S0": "ConversationLoader__assistantAvatar__pgT8uh",
  "l6": "assistantAvatarSkeleton__O_KWPv",
};

module.exports = exports;
